/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_OkInputs */

const en_mk_tut_issue_ok = /** @type {(inputs: Mk_Tut_Issue_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The issue appears in the list with its own number, \`DN-1\` for example, and opens from the board or the table too.`)
};

const id_mk_tut_issue_ok = /** @type {(inputs: Mk_Tut_Issue_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue muncul di daftar dengan nomor sendiri, misalnya \`DN-1\`, dan bisa dibuka dari papan maupun tabel.`)
};

/**
* | output |
* | --- |
* | "The issue appears in the list with its own number, `DN-1` for example, and opens from the board or the table too." |
*
* @param {Mk_Tut_Issue_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_ok = /** @type {((inputs?: Mk_Tut_Issue_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_ok(inputs)
	return en_mk_tut_issue_ok(inputs)
});